import { useEffect, useRef, type ReactNode } from 'react';

interface HScrollRowProps {
  children: ReactNode;
  className?: string;
}

// A horizontal scroll row that converts vertical mouse-wheel movement into
// horizontal scrolling while hovered — so a wheel/trackpad scroll pans the row.
export default function HScrollRow({ children, className = '' }: HScrollRowProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const onWheel = (e: WheelEvent) => {
      // Ignore genuine horizontal gestures (trackpads already scroll X).
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      // Nothing to scroll — let the page scroll normally.
      if (el.scrollWidth <= el.clientWidth) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };

    // Non-passive so preventDefault works.
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, []);

  return (
    <div ref={ref} className={'flex gap-3 overflow-x-auto scrollbar-hide pt-2 pb-2 -mx-1 px-1 ' + className}>
      {children}
    </div>
  );
}
